<div class="d-flex w-100 justify-center items-center h-screen">
  <h2>{{'unauthorized' | translate}}</h2>
</div>

